import "./atrapameSiPuedes.css";

import React, {useEffect} from "react";

import {DialogRedeem} from "./DialogRedeem";
import {DialogTerms} from "./DialogTerms";
import {RedeemView} from "./RedeemView";
import {getPromoData} from "./Infrastructure/getPromoData";
import {isAndroid} from "react-device-detect";
import {useSearchParams} from "react-router-dom";
import {useState} from "react";

const promoStateDefault = {
  loadingPromo: true,
  alreadyTaken: false,
  expiredPromo: false,
  error: false,
  errorMessage: "",
};

export const QR = () => {
  const [isOpenRedeemModal, setIsOpenRedeemModal] = useState(false);
  const [isOpenTermModal, setIsOpenTermModal] = useState(false);
  const toggleRedeemModal = () => setIsOpenRedeemModal(!isOpenRedeemModal);
  const toggleTermModal = () => setIsOpenTermModal(!isOpenTermModal);
  const [promoState, setPromoState] = useState(promoStateDefault);
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get("token");

  useEffect(() => {
    setPromoState((prevState) => ({...prevState, loadingPromo: true}));
    getPromoData(accessToken, setPromoState);
  }, [accessToken]);

  const openRedeemModal = () => {
    setIsOpenRedeemModal(true);
  };

  const onBackClick = () => {
    window.navigation.postMessage("native,,,pop,");
  };
  return (
    <div className="asp-container-wrapper">
      <div className="asp-container">
        <div class="asp-header-container">
          <div class="asp-back-arrow" onClick={onBackClick}>
            <div
              className={
                isAndroid
                  ? "fa fa-arrow-left app-bar-icono-color-new-appbar"
                  : "fa fa-chevron-left app-bar-icono-color-new-appbar"
              }
            />
          </div>
          <div class="asp-title-header">Petroprix</div>
        </div>
        <div className="asp-card-wrapper">
          <RedeemView
            promoState={promoState}
            toggleTermModal={toggleTermModal}
            openRedeemModal={openRedeemModal}
            setPromoState={setPromoState}
          />
        </div>
      </div>
      <DialogRedeem
        isOpen={isOpenRedeemModal}
        toggleModal={toggleRedeemModal}
      />
      <DialogTerms isOpen={isOpenTermModal} toggleModal={toggleTermModal} />
    </div>
  );
};
